import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  createStyles,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) =>
  createStyles({
    aspectRatioBox: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      // borderRadius: 24,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      textAlign: "center",
      fontSize: 20,
      color: "white",
      background: "no-repeat center center",
      backgroundImage: "url(/images/history/3.png)",
      backgroundSize: "100%",
      borderTopLeftRadius: 40,
      borderTopRightRadius: 40,
    },

    thumbTitle: {
      fontSize: 20,
      fontFamily: "GmarketSansBold",
      fontWeight: 700,
      paddingLeft: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },

    thumbContainer: {
      padding: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 0,
      },
    },

    topContainer: {
      padding: 32,
      [theme.breakpoints.down("xs")]: {
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 0,
      },
    },
  })
);

interface ArchiveThumbBoxContainerProps {
  archiveArr: any;
}

function ArchiveThumbBoxContainer({
  archiveArr,
}: ArchiveThumbBoxContainerProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));


  const [archiveTitle, setArchiveTitle] = useState<any>(null);
  const [archiveImgUrl, setArchiveImgUrl] = useState<any>(null);
  const [archiveArray, setArchiveArray] = useState<any>(null);

  useEffect(() => {
    if (archiveArr) {
      setArchiveTitle(archiveArr.title);
      setArchiveImgUrl(archiveArr.featuring_image.url);
      if (archiveArr.archive_sub_categories.length > 0) {
        setArchiveArray(archiveArr.archive_sub_categories);
      } else if (archiveArr.archive_sub_categories.length == 0) {
        setArchiveArray(null);
      }
    }

    return () => {
      setArchiveTitle(null);
      setArchiveArray(null);
      setArchiveImgUrl(null);
    };
  }, [archiveArr]);

  if (archiveArray && archiveTitle && archiveImgUrl) {
    return (
      <Grid xs={!matches ? 3 : 12} item className={classes.topContainer}>
        {/* <Box
          boxShadow={3}
          component={"div"}
          style={{ width: "100%", borderRadius: 12 }}
        > */}
        <div
          style={{
            border: "1px solid rgb(204, 204, 204)",
            borderRadius: 40,
            // boxShadow:
            //   "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px",
          }}
        >
          <Grid xs={12} item  className={classes.aspectRatioBox}>
            <Box
              component={"div"}
              className={classes.aspectRatioBoxInside}
              style={{
                backgroundImage: `url(${archiveImgUrl})`,
              }}
            ></Box>
          </Grid>
          <Grid xs={12} item style={{ padding: 16 }}>
            <Grid
              xs={12}
              item
              className={classes.thumbTitle}
            >
              {archiveTitle}
            </Grid>
            <Grid
              xs={12}
              item
              style={{
                paddingLeft: 32,
                paddingTop: 8,
                paddingBottom: 8,
                paddingRight: 32,
              }}
            >
              {archiveArray.map((element: any, index: any) => {
                return (
                  <Link to={`/archive/${element.route_slug}`}>
                    <div
                      style={{
                        fontSize: 16,
                        fontFamily: "Noto Sans KR",
                        fontWeight: 500,
                      }}
                    >
                      {element.title}
                    </div>
                  </Link>
                  // <ArchiveThumbBox
                  //   element={element}
                  // />
                );
              })}
            </Grid>
          </Grid>
        </div>
        {/* </Box> */}
      </Grid>
    );
  } else {
    return <div></div>;
  }
}
export default ArchiveThumbBoxContainer;
